import { combineReducers } from 'redux';
import { ConfigReducer } from './ConfigReducer';
import { NotificationReducer } from './NotificationReducer';
import { LoginReducer } from './LoginReducer';
import {RenderReducer} from './RenderReducer';

export const reducers = combineReducers({
    ConfigReducer,
    NotificationReducer,
    LoginReducer,
    RenderReducer,
});